import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import SeoHead from '../components/SeoHead';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <SeoHead
        title="404 - Page non trouvée | PulseCIO"
        description="La page que vous recherchez n'existe pas ou a été déplacée."
      />
      <Navbar />
      <main className="flex-1 container mx-auto px-6 py-20 flex items-center justify-center">
        <div className="text-center max-w-2xl">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-blue-600 dark:text-blue-400 mb-4">404</h1>
            <h2 className="text-3xl font-bold mb-4 text-black dark:text-white">
              Page non trouvée
            </h2>
            <p className="text-xl text-gray-700 dark:text-gray-300 mb-8">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
            </p>
          </div>
          
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 rounded-lg bg-blue-600 text-white font-semibold shadow-lg hover:bg-blue-700 transition-colors"
            >
              ← Retour à l'accueil
            </Link>
            
            <div className="pt-8">
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                Vous cherchez peut-être :
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <Link
                  to="/about"
                  className="px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                >
                  À propos
                </Link>
                <Link
                  to="/status"
                  className="px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                >
                  Status
                </Link>
                <a
                  href="https://app.pulsecio.com"
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                >
                  Application
                </a>
                <a
                  href="https://doc.pulsecio.com"
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                >
                  Documentation
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
